import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService } from 'src/app/shared-lib/domains/user';

@Component({
  selector: 'app-ads-subscription-modal',
  templateUrl: './ads-subscription-modal.component.html',
  styleUrls: ['./ads-subscription-modal.component.scss', '../../account/card-style.scss'],
  standalone: false
})
export class AdsSubscriptionModalComponent implements OnInit {

  @Input() ads: boolean;

  constructor(
    private modalController: ModalController,
    public userService: UserService
  ) { }

  ngOnInit() { }

  close() {
    this.modalController.dismiss();
  }

  onCloseAction() {
    this.modalController.dismiss({ accept: true });
  }
}
